import React, { Component } from 'react';
import $ from 'jquery';
import { Label, FormGroup, Form, Button, ButtonGroup, Input, Col, Row, Modal, ModalHeader, ModalFooter, ModalBody, InputGroup, UncontrolledTooltip } from 'reactstrap';
import Rows from '../components/Row'
import Header from '../components/Header'
import PrinterConnectionsTable from '../components/tables/PrinterConnectionsTable'
import { connect } from 'react-redux'
import AuthHOC from './Auth'
import { withAlert } from 'react-alert'
import NewPollingServiceModal from '../components/modals/NewPollingServiceModal';
import PollerServiceTable from '../components/tables/PollerServiceTable';
import DeletePollerModal from '../components/modals/DeletePollerModal';
import { Stack, Typography, Box, Button as MuiButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

class PollerView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            maliboxPollers: [],
            checkedMaliboxPollers: [],
            directoryPollers: [],
            checkedDirPollers: [],
            addPollerServiceModalVisible: false,
            removePollerServiceModalVisible: false
        }
    }

    componentDidMount = () => {
        this.getPollerMailboxes()
        this.getPollerDirectories()
    }

    getPollerMailboxes = () => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/poller/inboxes', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(res => res.json())
            .then((result) => {
                this.setState({
                    maliboxPollers: result,
                    checkedMaliboxPollers: []
                })
            })
            .catch(error => {
                console.error(error)
            });
    }

    getPollerDirectories = () => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/poller/directories', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(res => res.json())
            .then((result) => {
                this.setState({
                    directoryPollers: result,
                    checkedDirPollers: []
                })
            })
            .catch(error => {
                console.error(error)
            });
    }

    toggleAddServiceModal = () => {
        this.setState({
            addPollerServiceModalVisible: !this.state.addPollerServiceModalVisible
        })
    }

    addNewPollerCompelte = () => {
        this.setState({
            addPollerServiceModalVisible: false
        })
        this.getPollerMailboxes()
        this.getPollerDirectories()
    }

    mailboxRowCheckedChanged = (id) => {
        var found = this.state.maliboxPollers.find(element => {
            return element._id == id;
        });

        if (!this.state.checkedMaliboxPollers.includes(found)) {
            this.setState(prevState => ({
                checkedMaliboxPollers: prevState.checkedMaliboxPollers.concat(found)
            }))
        }
        else {
            this.setState(prevState => ({
                checkedMaliboxPollers: prevState.checkedMaliboxPollers.filter(j => found !== j)
            }))
        }
    }

    mailboxRowCheckAll = () => {
        if (this.state.checkedMaliboxPollers.length == this.state.maliboxPollers.length)
            this.setState({
                checkedMaliboxPollers: []
            })
        else
            this.setState({
                checkedMaliboxPollers: this.state.maliboxPollers
            })
    }

    directoryRowCheckedChanged = (id) => {
        var found = this.state.directoryPollers.find(element => {
            return element._id == id;
        });

        if (!this.state.checkedDirPollers.includes(found)) {
            this.setState(prevState => ({
                checkedDirPollers: prevState.checkedDirPollers.concat(found)
            }))
        }
        else {
            this.setState(prevState => ({
                checkedDirPollers: prevState.checkedDirPollers.filter(j => found !== j)
            }))
        }
    }

    directoryRowCheckAll = () => {
        if (this.state.checkedDirPollers.length == this.state.directoryPollers.length)
            this.setState({
                checkedDirPollers: []
            })
        else
            this.setState({
                checkedDirPollers: this.state.directoryPollers
            })
    }

    deleteSelectedPollers = () => {
        const mailboxPollers = this.state.checkedMaliboxPollers;
        const dirPollers = this.state.checkedDirPollers;

        if (dirPollers.length > 0)
            this.deleteDirectoryService();

        if (mailboxPollers.length > 0)
            this.deleteMailboxService();
    }

    startMailboxService = () => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/poller/start_mailbox_pollers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state.checkedMaliboxPollers)
        })
            .then(res => res.json())
            .then((result) => {
                this.getPollerMailboxes();
            })
            .catch(error => {
                console.error(error)
            });
    }

    stopMailboxService = () => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/poller/stop_mailbox_pollers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state.checkedMaliboxPollers)
        })
            .then(res => res.json())
            .then((result) => {
                this.getPollerMailboxes();
            })
            .catch(error => {
                console.error(error)
            });
    }

    startDirectoryService = () => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/poller/start_directory_pollers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state.checkedDirPollers)
        })
            .then(res => res.json())
            .then((result) => {
                this.getPollerDirectories();
            })
            .catch(error => {
                console.error(error)
            });
    }

    stopDirectoryService = () => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/poller/stop_directory_pollers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state.checkedDirPollers)
        })
            .then(res => res.json())
            .then((result) => {
                this.getPollerDirectories();
            })
            .catch(error => {
                console.error(error)
            });
    }

    render() {
        const { parsed, localisation } = this.props;

        let addPollerModal = <div />
        let removePollerModal = <div />
        let runningInboxPollers = this.state.checkedMaliboxPollers.filter(inbox => inbox.status == 'Running');
        let runningdirPollers = this.state.checkedDirPollers.filter(poller => poller.status == 'Running');

        if (this.state.addPollerServiceModalVisible)
            addPollerModal =
                <NewPollingServiceModal
                    visible={this.state.addPollerServiceModalVisible}
                    toggle={this.toggleAddServiceModal}
                    addCompleted={this.addNewPollerCompelte}
                />

            return (
            <div className="App">
                <Header visible={!parsed.X3} />
                <div id="s-site-body" className="page-wrapper">
                <div className="s-page">
                    <div className="s-page-header">
                        <Stack spacing={0.5} alignItems="flex-start" sx={{ mb: 3, textAlign: "left" }}>
                            <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                {localisation['PSR'] ? localisation['PSR'].element_lang : 'Polling Services'}
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Manage mailbox and directory pollers
                            </Typography>
                        </Stack>
                        <div className="s-page-actions">
                            <MuiButton
                                onClick={this.toggleAddServiceModal}
                                variant="contained"
                                startIcon={<AddIcon />}
                                disableElevation
                                type="button"
                                sx={{ textTransform: 'none' }}
                            >
                                {localisation['add_new_button'] ? localisation['add_new_button'].element_lang : 'Add New'}
                            </MuiButton>
                        </div>
                    </div>
                    <div className="s-content-panel">
                    <header class="s-h2-head-search"><div title="Document" class="s-h2-title">{localisation['mailbox_pollers_text'] ? localisation['mailbox_pollers_text'].element_lang : 'Mailbox Pollers'}</div></header>
                    <PollerServiceTable
                        checked
                        delete={this.remove}
                        refresh={this.getPollerMailboxes}
                        selectAll={this.mailboxRowCheckAll}
                        onRowClicked={this.rowClicked}
                        checkChange={this.mailboxRowCheckedChanged}
                        logs={this.state.maliboxPollers}
                        checkedlogs={this.state.checkedMaliboxPollers}
                        type="mailbox" />

                    <Box sx={{ display: 'flex', gap: 2, mt: 2, justifyContent: 'flex-end' }}>
                        <MuiButton onClick={this.stopMailboxService} disabled={this.state.checkedMaliboxPollers.length == 0} variant="outlined" color="error">{localisation['stop_button'] ? localisation['stop_button'].element_lang : 'Stop'}</MuiButton>
                        <MuiButton onClick={this.startMailboxService} disabled={this.state.checkedMaliboxPollers.length == 0} variant="contained" color="success">{localisation['start_button'] ? localisation['start_button'].element_lang : 'Start'}</MuiButton>
                    </Box>

                    <header class="s-h2-head-search"><div title="Document" class="s-h2-title">{localisation['directory_pollers_text'] ? localisation['directory_pollers_text'].element_lang : 'Directory Pollers'}</div></header>
                    <PollerServiceTable
                        checked
                        delete={this.remove}
                        refresh={this.getPollerDirectories}
                        selectAll={this.directoryRowCheckAll}
                        onRowClicked={this.rowClicked}
                        checkChange={this.directoryRowCheckedChanged}
                        logs={this.state.directoryPollers}
                        checkedlogs={this.state.checkedDirPollers}
                        type="directory" 
                        columnConfig={{ checkbox: true, actions: true }}
                    />

                    <Box sx={{ display: 'flex', gap: 2, mt: 2, justifyContent: 'flex-end' }}>
                        <MuiButton onClick={this.stopDirectoryService} disabled={this.state.checkedDirPollers.length == 0} variant="outlined" color="error">
                            {localisation['stop_button'] ? localisation['stop_button'].element_lang : 'Stop'}
                        </MuiButton>
                        <MuiButton onClick={this.startDirectoryService} disabled={this.state.checkedDirPollers.length == 0} variant="contained" color="success">
                            {localisation['start_button'] ? localisation['start_button'].element_lang : 'Start'}
                        </MuiButton>
                    </Box>
                    </div>

                </div>
                </div>
                <br />
                
                {addPollerModal}
                {removePollerModal}
            </div>
        );
    }
}
export default connect(state => state)(AuthHOC(withAlert()(PollerView), { name: 'polling_service' }));